import React from 'react';
import { Square, Layers } from 'lucide-react';

const SurfaceParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  surfaceTypes,
  surfaceConditions
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Площадь поверхности */}
      <div className={formData.calculationType === 'room' ? 'md:col-span-2 bg-gray-50 dark:bg-gray-800/30 p-3 rounded-lg' : ''}>
        <label htmlFor="surfaceArea" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Square className="w-4 h-4 mr-2 text-indigo-500" />
          {formData.calculationType === 'room' 
            ? 'Рассчитанная площадь поверхности (м²)' 
            : 'Площадь поверхности (м²)'}
        </label>
        <div className="relative">
          <input
            type="text"
            id="surfaceArea"
            name="surfaceArea"
            value={formData.surfaceArea}
            onChange={handleInputChange}
            disabled={formData.calculationType === 'room'}
            className={`form-input w-full ${errors.surfaceArea ? 'input-error' : ''}`}
            placeholder="Введите площадь"
          />
          <span className="absolute inset-y-0 right-3 flex items-center text-gray-500 dark:text-gray-400 pointer-events-none">
            м²
          </span>
        </div>
        {errors.surfaceArea && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.surfaceArea}
          </p>
        )}
        {formData.calculationType === 'room' && (
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400 italic">
            Площадь рассчитана автоматически из размеров помещения
          </p>
        )}
      </div>

      {/* Тип поверхности */}
      <div>
        <label htmlFor="surfaceType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Layers className="w-4 h-4 mr-2 text-indigo-500" />
          Тип поверхности
        </label>
        <select
          id="surfaceType"
          name="surfaceType"
          value={formData.surfaceType}
          onChange={handleInputChange}
          className={`form-select w-full ${errors.surfaceType ? 'input-error' : ''}`}
        >
          <option value="">Выберите тип поверхности</option>
          {surfaceTypes.map((type) => (
            <option key={type.id} value={type.id}>
              {type.name}
            </option>
          ))}
        </select>
        {errors.surfaceType && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.surfaceType}
          </p>
        )}
      </div>

      {/* Состояние поверхности */}
      <div>
        <label htmlFor="surfaceCondition" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Состояние поверхности
        </label>
        <select
          id="surfaceCondition"
          name="surfaceCondition"
          value={formData.surfaceCondition}
          onChange={handleInputChange}
          className={`form-select w-full ${errors.surfaceCondition ? 'input-error' : ''}`}
        >
          {surfaceConditions.map((condition) => (
            <option key={condition.id} value={condition.id}>
              {condition.name}
            </option>
          ))}
        </select>
        {errors.surfaceCondition && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.surfaceCondition}
          </p>
        )}
      </div>

      {/* Включать ли потолок */}
      <div className="md:col-span-2">
        <label className="inline-flex items-center">
          <input
            type="checkbox"
            name="ceilingIncluded"
            checked={formData.ceilingIncluded}
            onChange={handleInputChange}
            className="form-checkbox"
          />
          <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
            Включить потолок в расчет
          </span>
        </label>
      </div>
    </div>
  );
};

export default SurfaceParametersSection;